import React, { Fragment, useState, useEffect } from "react";
import { Row, Col, Card } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import PageTitle from "../../layouts/PageTitle";
import swal from "sweetalert";
import api from "../../../api";
import FilePreview from "../Common/FilePreview";
import Select from "react-select";
import { useSearchParams } from "react-router-dom";
const TCReportAdd = () => {
 const navigate = useNavigate();
const [searchParams] = useSearchParams();

const workOrderFromUrl = searchParams.get("workOrder") || "";
const projectFromUrl = searchParams.get("project") || "";
 const [projects, setProjects] = useState([]);
 const [boqItems, setBoqItems] = useState([]);
 const [loading, setLoading] = useState(false);

 const [form, setForm] = useState({
 workOrder: "",
 testDate: new Date().toISOString().split("T")[0],
 clientComments: "",
 });

 // =====================================================
 // MULTIPLE ITEMS
 // =====================================================
 const [items, setItems] = useState([
 {
 equipment: "",
 testPerformed: "",
 testResults: "",
 status: "Pending",
 description: "",
 unit: "",
 testedQty: 1, // NEW FIELD
 },
 ]);

 const addItem = () => {
 setItems([
 ...items,
 {
 equipment: "",
 testPerformed: "",
 testResults: "",
 status: "Pending",
 description: "",
 unit: "",
 testedQty: 1, // ADD THIS

 },
 ]);
 };

 const removeItem = (index) => {
 setItems(items.filter((_, i) => i !== index));
 };

 const handleItemChange = (index, field, value) => {
 const updated = [...items];
 updated[index][field] = value;

 // When equipment selected → auto-fill
 if (field === "equipment") {
 const selected = boqItems.find((b) => b._id === value);

 updated[index].boqItemId = selected?._id || "";
 updated[index].testPerformed = selected?.testType || "";
 updated[index].description = selected ? `[WLI-${selected.wlino || "-"}] ${selected.itemName || selected.description}` : "";
 updated[index].unit = selected?.unit || "";

 // Optional: set max allowed qty
 updated[index].maxQty = selected?.quantity || 0;
 }

 // VALIDATE TESTED QTY
 if (field === "testedQty") {
 const boqId = updated[index].equipment;
 const boqItem = boqItems.find((b) => b._id === boqId);

 const boqQty = Number(boqItem?.quantity || 0);
 const enteredQty = Number(value || 0);

 if (enteredQty > boqQty) {
 swal(
 "Quantity Exceeded",
 `You cannot test more than BOQ quantity (${boqQty})`,
 "warning",
 );

 updated[index].testedQty = boqQty; // auto-correct
 }
 }

 setItems(updated);
 };

 // =====================================================
 // LOAD PROJECTS
 // =====================================================
 useEffect(() => {
 const fetchProjects = async () => {
 try {
 const res = await api.get("/work-orders");
 if (res.data.success) setProjects(res.data.data);
 } catch (err) {
 swal("Error", err.message, "error");
 }
 };
 fetchProjects();
 }, []);
useEffect(() => {
 if (workOrderFromUrl && projects.length > 0) {
 setForm((prev) => ({
 ...prev,
 workOrder: workOrderFromUrl,
 }));

 loadBoq(workOrderFromUrl);
 }
}, [projects, workOrderFromUrl]);
 // =====================================================
 // CHANGE PROJECT → FETCH BOQ
 // =====================================================
 const handleChange = async (e) => {
 const { name, value } = e.target;
 setForm((p) => ({ ...p, [name]: value }));

 if (name === "workOrder") {
 try {
 const res = await api.get(`/work-orders/${value}/boq`);

 if (res.data.success) setBoqItems(res.data.data);
 else setBoqItems([]);

 setItems([
 {
 equipment: "",
 testPerformed: "",
 testResults: "",
 status: "Pending",
 description: "",
 unit: "",
 testedQty: 1, // ADD

 },
 ]);
 } catch {
 swal("Error", "Failed to fetch BOQ items", "error");
 setBoqItems([]);
 }
 }
 };

 // Prevent duplicate BOQ selection
 const isItemUsed = (id, currentIndex) =>
 items.some((it, idx) => idx !== currentIndex && it.equipment === id);

 // =====================================================
 // FILE UPLOAD
 // =====================================================
 const handleFile = (e) => {
 if (e.target.files.length > 0) {
 setForm((p) => ({ ...p, reportFile: e.target.files[0] }));
 }
 };

 // =====================================================
 // SUBMIT HANDLER
 // =====================================================
 const handleSubmit = async (e) => {
 e.preventDefault();

 if (!form.workOrder) {
 swal("Error", "Please select a work order", "error");
 return;
 }

 // Validate all items
 for (const it of items) {
 if (
 !it.equipment ||
 !it.testPerformed ||
 !it.testResults ||
 !it.testedQty
 ) {
 swal("Error", "All equipment rows must be complete.", "error");
 return;
 }
 }

 setLoading(true);

 try {
 const fd = new FormData();

 fd.append("workOrder", form.workOrder);

 fd.append("testDate", form.testDate);
 fd.append("clientComments", form.clientComments || "");
 fd.append("items", JSON.stringify(items)); // Includes description + unit

 if (form.reportFile) fd.append("testReport", form.reportFile);

 const res = await api.post("/testing-commissioning", fd, {
 headers: { "Content-Type": "multipart/form-data" },
 });

 if (res.data.success) {
 swal("Success", "TC Report Added Successfully", "success");
 navigate(
 workOrderFromUrl
 ? `/tc-report?${projectFromUrl ? `project=${projectFromUrl}&` : ""}workOrder=${workOrderFromUrl}`
 : "/tc-report"
);
 } else {
 swal("Error", res.data.message, "error");
 }
 } catch (err) {
 swal("Error", err.message, "error");
 }

 setLoading(false);
 };

 const required = <span style={{ color: "red" }}>*</span>;
const loadBoq = async (workOrderId) => {
 try {
 const res = await api.get(`/work-orders/${workOrderId}/boq`);

 if (res.data.success) setBoqItems(res.data.data);
 else setBoqItems([]);

 setItems([
 {
 equipment: "",
 testPerformed: "",
 testResults: "",
 status: "Pending",
 description: "",
 unit: "",
 testedQty: 1,
 },
 ]);
 } catch {
 swal("Error", "Failed to fetch BOQ items", "error");
 setBoqItems([]);
 }
};
 return (
 <Fragment>
 <PageTitle activeMenu="Add TC Report" motherMenu="ITC" />

 <Row>
 <Col lg={12}>
 <Card>
 <Card.Header className="d-flex justify-content-between">
 <Card.Title>Add TC Report</Card.Title>
 <button
 className="btn btn-secondary"
 onClick={() =>
 navigate(
 workOrderFromUrl
 ? `/tc-report?${projectFromUrl ? `project=${projectFromUrl}&` : ""}workOrder=${workOrderFromUrl}`
 : "/tc-report"
 )
}
 >
 Back
 </button>
 </Card.Header>

 <Card.Body>
 <form onSubmit={handleSubmit} encType="multipart/form-data">
 {/* PROJECT */}
 <div className="mb-3">
 <label>Work Order *</label>

 <select
 name="workOrder"
 className="form-select"
 value={form.workOrder}
 onChange={handleChange}
 >
 <option value="">Select Work Order</option>
 {projects.map((wo) => (
 <option key={wo._id} value={wo._id}>
 {wo.woNo}{wo.label ? ` – ${wo.label}` : ""}
 </option>
 ))}
 </select>
 </div>

 {/* EQUIPMENT LIST */}
 <div className="mb-3">
 <h5>Equipment List</h5>
 <button
 type="button"
 className="btn btn-success btn-sm"
 onClick={addItem}
 >
 + Add Equipment
 </button>
 </div>

 {items.map((item, idx) => (
 <div key={idx} className="border p-3 mb-3 rounded">
 {/* Header */}
 <div className="d-flex justify-content-between">
 <strong>Equipment #{idx + 1}</strong>
 {idx > 0 && (
 <button
 type="button"
 className="btn btn-danger btn-sm"
 onClick={() => removeItem(idx)}
 >
 Remove
 </button>
 )}
 </div>

 {/* EQUIPMENT */}
 <div className="mt-2">
 <label>Equipment {required}</label>
 <Select
 placeholder="Search & select Equipment..."
 isClearable
 options={boqItems.map((b) => ({
 value: b._id,
 label: `[WLI-${b.wlino || "-"}] ${b.itemName} — ${b.quantity} ${b.unit || ""}`,
 isDisabled: isItemUsed(b._id, idx),
 }))}
 value={
 boqItems
 .filter((b) => b._id === item.equipment)
 .map((b) => ({
 value: b._id,
 label: `[WLI-${b.wlino || "-"}] ${b.itemName} — ${b.quantity} ${b.unit || ""}`,
 }))[0] || null
 }
 onChange={(selected) => {
 if (selected) {
 handleItemChange(idx, "equipment", selected.value);
 } else {
 handleItemChange(idx, "equipment", "");
 }
 }}
 styles={{
 control: (base) => ({
 ...base,
 minHeight: "38px",
 }),
 }}
/>

 </div>

 {/* DESCRIPTION */}
 <div className="mt-2">
 <label>Description</label>
 <input
 className="form-control"
 value={item.description}
 readOnly
 />
 </div>

 {/* UNIT */}
 <div className="mt-2">
 <label>Unit</label>
 <input
 className="form-control"
 value={item.unit}
 readOnly
 />
 </div>
 {/* TESTED QUANTITY */}
 <div className="mt-2">
 <label>No. of Items Tested *</label>
 <input
 type="number"
 min="1"
 className="form-control"
 value={item.testedQty}
 onChange={(e) =>
 handleItemChange(idx, "testedQty", e.target.value)
 }
 />
 </div>
 {item.equipment && (
 <small className="text-muted">
 BOQ Quantity:{" "}
 {
 boqItems.find((b) => b._id === item.equipment)
 ?.quantity
 }
 </small>
 )}

 {/* TEST PERFORMED */}
 <div className="mt-2">
 <label>Test Performed {required}</label>
 <input
 className="form-control"
 value={item.testPerformed}
 onChange={(e) =>
 handleItemChange(idx, "testPerformed", e.target.value)
 }
 />
 </div>

 {/* TEST RESULTS */}
 <div className="mt-2">
 <label>Test Results {required}</label>
 <select
 className="form-select"
 value={item.testResults}
 onChange={(e) =>
 handleItemChange(idx, "testResults", e.target.value)
 }
 >
 <option value="">Select Result</option>
 <option value="Pass">Pass</option>
 <option value="Fail">Fail</option>
 <option value="Conditional Pass">
 Conditional Pass
 </option>
 </select>
 </div>

 {/* ITEM STATUS */}
 <div className="mt-2">
 <label>Status</label>
 <select
 className="form-select"
 value={item.status}
 onChange={(e) =>
 handleItemChange(idx, "status", e.target.value)
 }
 >
 <option value="Pending">Pending</option>
 <option value="NC Raised">NC Raised</option>
 <option value="Retest Required">Retest Required</option>
 </select>
 </div>
 </div>
 ))}

 {/* TEST DATE */}
 <div className="mb-3">
 <label>Test Date {required}</label>
 <input
 type="date"
 name="testDate"
 className="form-control"
 value={form.testDate}
 onChange={handleChange}
 />
 </div>

 {/* FILE UPLOAD */}
 <div className="mb-3">
 <label>Attach Test Report {required}</label>
 <input
 type="file"
 className="form-control"
 onChange={handleFile}
 />
 <FilePreview 
 file={form.testReport} 
 onRemove={() => setForm(prev => ({ ...prev, testReport: null }))} 
 />
 </div>

 {/* COMMENTS */}
 <div className="mb-3">
 <label>Client Comments</label>
 <textarea
 className="form-control"
 rows={3}
 value={form.clientComments}
 name="clientComments"
 onChange={handleChange}
 />
 </div>

 {/* BUTTONS */}
 <button
 type="submit"
 className="btn btn-primary me-2"
 disabled={loading}
 >
 {loading ? "Saving..." : "Save"}
 </button>

 <button
 type="button"
 className="btn btn-danger"
 onClick={() =>
 navigate(
 workOrderFromUrl
 ? `/tc-report?${projectFromUrl ? `project=${projectFromUrl}&` : ""}workOrder=${workOrderFromUrl}`
 : "/tc-report"
 )
}
 >
 Cancel
 </button>
 </form>
 </Card.Body>
 </Card>
 </Col>
 </Row>
 </Fragment>
 );
};

export default TCReportAdd;
